import SlowMotionVideoIcon from '@mui/icons-material/SlowMotionVideo';
import {
  Box,
  Divider,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';

/**
 * The properties for the mobile drawer toggle
 */
interface MobileDrawerToggleProps {
  /**
   * This is the state of the drawer that this toggle is associated with
   */
  drawerState: 'showing' | 'hidden';

  /**
   * Set the state of the navigation
   * @param _ A boolean to show or hide the navigation
   */
  setShowNav: () => void;

  /**
   * Show this element left of the toggle button
   */
  leftSlot?: JSX.Element;

  /**
   * Show this element right of the toggle button
   */
  rightSlot?: JSX.Element;
}

/**
 * A button at the bottom of the screen to control the navigation on small screens
 */
const MobileDrawerToggle = ({
  drawerState,
  setShowNav,
  leftSlot = undefined,
  rightSlot = undefined,
}: MobileDrawerToggleProps) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    !isMd && (
      <Box paddingBottom="10px" textAlign="center" width="100%">
        <Divider sx={{ marginBottom: '10px' }} />
        <Box
          width="100%"
          display="flex"
          justifyContent={leftSlot ?? rightSlot ? 'space-between' : 'center'}
          paddingX="1em"
          gap=".5em"
        >
          {leftSlot}
          <IconButton
            sx={{ padding: 0 }}
            onClick={() => setShowNav()}
            size="large"
          >
            <SlowMotionVideoIcon
              sx={{
                fontSize: '40px',
                transform:
                  drawerState == 'showing' ? 'rotate(90deg)' : 'rotate(-90deg)',
              }}
            />
          </IconButton>
          {rightSlot}
        </Box>
      </Box>
    )
  );
};

export default MobileDrawerToggle;
